import {inject, Injectable} from '@angular/core';
import {YandexDataCheckApiService} from "./yandex-data-check-api.service";
import {
  SiteClicksData,
  YandexDataCheckDialogData,
  YandexMetricsParams
} from "../types/yandex-data-check.types";
import {RecordData} from "../../../../types/records-table.types";
import {BaseModalService} from "../../services/base-modal.service";

@Injectable({
  providedIn: 'root'
})
export class YandexDataCheckService {
  private yandexDataCheckApiService: YandexDataCheckApiService = inject(YandexDataCheckApiService);
  private baseModalService: BaseModalService = inject(BaseModalService);

  public getYandexMetrics(yandexMetricsParams: YandexMetricsParams): Promise<SiteClicksData> {
    return new Promise((resolve, reject) => {
      this.yandexDataCheckApiService.getYandexMetrics(yandexMetricsParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updateYandexMetrics(yandexMetricsParams: YandexMetricsParams): Promise<RecordData> {
    return new Promise((resolve, reject) => {
      this.yandexDataCheckApiService.updateYandexMetrics(yandexMetricsParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public setYandexMetricsParams(yandexDataCheckDialogData: YandexDataCheckDialogData): YandexMetricsParams {
    return {
      path: yandexDataCheckDialogData.parentPath,
      id: this.baseModalService.getRecordCalendarId(yandexDataCheckDialogData.parentData)
    }
  }
}
